export default defineNuxtPlugin(async () => {
    const { fetchUser } = useAuth();

    if (process.client) {
        fetchUser().then();
    }
});
